import { render, staticRenderFns } from "./Translatable.vue?vue&type=template&id=607cad4a&"
import script from "./Translatable.vue?vue&type=script&lang=js&"
export * from "./Translatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports